/**
 * @file geneDiseasegeneDiseaseClassificationNew.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jan 11, 2022 13:47
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    geneDiseaseClassificationNewDialogSet,
} from 'src/store/actions/geneModel/geneModelPages.actions';

import {
    GENE_DISEASE_CLASSIFICATION_NEW_REQUEST,
    geneDiseaseClassificationNewSuccess,
    geneDiseaseClassificationNewFailure,
} from 'src/store/actions/geneModel/geneModelDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/geneModel/geneDiseaseClassification/new';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            geneModelId: payload.geneModelId,
            geneDiseaseId: payload.geneDiseaseId,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(geneDiseaseClassificationNewSuccess(resp.payload));

        // open the new dialog
        yield put(geneDiseaseClassificationNewDialogSet(true));

    } catch (error) {
        yield put(geneDiseaseClassificationNewFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* createRequestMonitor() {
    yield takeLatest(GENE_DISEASE_CLASSIFICATION_NEW_REQUEST, createRequestSaga);
}
